import { gql } from "@apollo/client";

export default gql`
  query SearchEpisodes($providers: [String!], $limit: Int, $lastReportId: Int, $adSearch: AdvancedSearch) {
    episodesSearchResult(providers: $providers, limit: $limit, lastReportId: $lastReportId, adSearch: $adSearch) {
      lastReport {
        reportid
      }
      episodes {
        labid
        reportid
        patientid
        status
        fullnameTitleCase
        dob
        dateCreated
        allEpisodeTests
        referrer
        isRead
        labnoDigitOnly
        reportingProviderNo
        hasAbnormalStatus
        panels {
          labid
          reportid
          labnumber
          testname
          lastViewed
          firstViewed
          hasAbnormalStatus
          interimStatus
          isRead
          dateCreated
        }
        urgentStatus
        shareFromReport {
          shareFromUserId
          shareFromreportId
          shareFromUsername
        }
      }
    }
  }
`;
